export interface EstadoPaso {
    estado: 'done' | 'in-progress' | 'pending' | 'error';
    fecha?: string;
    errorMessage?: string;
    errorCode?: string;
}

export const PASOS_SRT = [
    'Inicio de presentación',
    'Anexo I — Establecimientos',
    'Anexo V — Sustancias',
    'Anexo III — Nómina',
    'Consolidación'
];

/**
 * Cada registro de historial guarda el paso MÁS ALTO alcanzado en un intento
 * (Back-APICancerigenos persiste una vez por invocación, no una vez por
 * sub-paso SOAP) — por eso alcanzar el paso N implica que los pasos 1..N-1
 * de ese mismo intento también se completaron.
 *
 * Vive acá y no dentro de un componente porque la consumen dos pantallas: el
 * drawer de proceso por informe (Presentaciones) y el de detalle por CUIT
 * (PresentacionesSVCC).
 */
export function construirEstadosPorPaso(
    historial: any[] | undefined,
    cantidadPasos = PASOS_SRT.length
): EstadoPaso[] {
    const registros = Array.isArray(historial) ? historial : [];
    const ultimoPorPaso = new Map<number, any>();
    registros.forEach((registro) => ultimoPorPaso.set(registro.paso, registro));

    const pasoMaximoAlcanzado = registros.length
        ? Math.max(...registros.map((registro) => registro.paso))
        : 0;
    const ultimoRegistro = registros[registros.length - 1];
    const ultimoIntentoFallo = ultimoRegistro?.resultado === 'ERROR';

    return Array.from({ length: cantidadPasos }, (_, indice) => {
        const paso = indice + 1;
        const registroDeEstePaso = ultimoPorPaso.get(paso);

        if (paso < pasoMaximoAlcanzado || (paso === pasoMaximoAlcanzado && !ultimoIntentoFallo)) {
            return {
                estado: 'done' as const,
                fecha: registroDeEstePaso?.fechaCreacion ?? ultimoRegistro?.fechaCreacion
            };
        }
        if (paso === pasoMaximoAlcanzado && ultimoIntentoFallo) {
            const registroError = registroDeEstePaso ?? ultimoRegistro;
            return {
                estado: 'error' as const,
                fecha: registroError?.fechaCreacion,
                errorMessage: registroError?.log?.errorMessage,
                errorCode: registroError?.log?.errorCode
            };
        }
        if (paso === pasoMaximoAlcanzado + 1) {
            return { estado: 'in-progress' as const };
        }
        return { estado: 'pending' as const };
    });
}
